import {RepositoryFactory} from '../metrics/core.js';
import {wrap} from '../metrics/custom.js';
import {some} from '../common/utilities.js';
import {getLogger} from '../logger.js';
import {Draft, produce} from 'immer';
import {IOGateway} from '../../gateway';

const log = getLogger('gateway.metrics');
async function publisher<T extends keyof IOGateway.MetricPublishersConfig>(type: T, config?: IOGateway.MetricPublishersConfig[T]): Promise<RepositoryFactory | undefined> {
    if (type === 'rest') {
        const {restRepositoryFactory} = await import('../metrics/rest.js');
        return await restRepositoryFactory(config as IOGateway.RestMetricsPublisherConfig);
    } else if (type === 'file') {
        if (typeof process !== 'undefined') {
            const {fileRepositoryFactory} = await import('../metrics/file.js');
            return await fileRepositoryFactory(config as IOGateway.FileMetricsPublisherConfig);
        } else {
            throw new Error(`file publisher is supported only in nodejs`);
        }
    }
    return undefined;
}

export async function metrics(config?: IOGateway.MetricsConfig, endpoint?: string): Promise<RepositoryFactory[]> {
    const c = config ?? {publishers: []};
    return Promise.all((c.publishers)
        .map(async (f) => {
            try {
                if (typeof f === 'string') {
                    return await publisher(f, c[f]);
                } else {
                    //add gw url to custom publisher's context
                    const conf = produce(f, (draft: Draft<IOGateway.CustomMetricsPublisherConfig>) => {
                        if (endpoint) {
                            draft.context = draft.context || {};
                            draft.context.gw = draft.context.gw || {url: endpoint};
                            draft.context.gw.url = endpoint;
                        }
                    });
                    return await wrap(conf);
                }
            } catch (e) {
                log.error(`failed to create repository factory ${JSON.stringify(f)}`, e);
                return undefined;
            }
        })).then((rs) => rs.filter(some<RepositoryFactory>));
}
